module.exports = __webpack_public_path__ + "static/media/pool-service.71322314.svg";